exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Scroll__scrollWrapper___1VzJ- {\n  display: flex;\n  flex-direction: column; }\n  .Scroll__scrollWrapper___1VzJ- .Scroll__scrollable___2SmPL {\n    flex-grow: 1;\n    min-height: 0px;\n    overflow-y: auto; }\n", ""]);

// exports
exports.locals = {
	"scrollWrapper": "Scroll__scrollWrapper___1VzJ-",
	"scrollable": "Scroll__scrollable___2SmPL"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Scroll/Scroll.scss
// module id = 689
// module chunks = 0